/**
 * CategoryFilter Component
 *
 * Filter blog posts by category with chip-style buttons
 */

import type { BlogCategory } from "../../content/blog/types";
import { CATEGORY_INFO } from "../../content/blog/types";

interface CategoryFilterProps {
  categories: BlogCategory[];
  selectedCategory: BlogCategory | null;
  onSelect: (category: BlogCategory | null) => void;
  showAll?: boolean;
}

export function CategoryFilter({
  categories,
  selectedCategory,
  onSelect,
  showAll = true,
}: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {showAll && (
        <button
          onClick={() => onSelect(null)}
          className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
            selectedCategory === null
              ? "bg-teal-500 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          All Posts
        </button>
      )}
      {categories.map((category) => {
        const info = CATEGORY_INFO[category];
        const isSelected = selectedCategory === category;
        return (
          <button
            key={category}
            onClick={() => onSelect(isSelected ? null : category)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              isSelected
                ? "bg-teal-500 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            title={info.description}
          >
            {info.label}
          </button>
        );
      })}
    </div>
  );
}

export default CategoryFilter;
